'use strict';

import { isMobileRes, isMobileDevice } from "../utils/Utils";

class BrandCategorySelector {
  constructor(mainElement) {
    this.main = mainElement;
    if (!this.main) return;

    this._list = this.main.querySelector('.brand-selector__list');
    this._actionBtn = this.main.querySelector('.action_btn');
    this._searchInput = this.main.querySelector('.search_input');
    this._valueLabel = this.main.querySelector('.value_label');
    this._closeBtn = this.main.querySelector('.close_btn');
    this._noResults = this.main.querySelector('.no_results_item');

    this._currentBrandCategoryId = null;
    this._currentBrandCategoryName = null;
    this._isOpen = false;
    this._readOnly = false;

    Array.from(this.main.querySelectorAll('.brand_category_item'))
      .forEach(item =>
        item.addEventListener('click', this._onClickBrandCategoryItem.bind(this))
      );
    this._closeBtn.addEventListener('click', this.hide.bind(this));
    this._searchInput.addEventListener('input', this._onSearchInputChange.bind(this));
    this._actionBtn.addEventListener('click', this._onClickActionBtn.bind(this));
    document.addEventListener('click', this._onClickDocument.bind(this));
  }

  show() {
    this._isOpen = true;
    this._searchInput.value = '';
    this._onSearchInputChange();
    this._searchInput.focus();

    if (isMobileDevice() || isMobileRes()) {
      //document.body.classList.add('block-scroll'); Comentado por que genera bugs cuando el selector esta dentro de un modal
    }

    this.main.classList.add('brand-selector--open');
    setTimeout(() => {
      this.main.classList.add('brand-selector--open-anim');
    }, 0);

    this.hideTooltip();
  }

  hide() {
    this._isOpen = false;
    this.main.classList.remove('brand-selector--open', 'brand-selector--open-anim');
    //document.body.classList.remove('block-scroll'); Comentado por que genera bugs cuando el selector esta dentro de un modal
  }

  clear() {
    this.value = null;
    this._currentBrandCategoryId = null;
    this._currentBrandCategoryName = null;
    this._searchInput.value = '';
    this._onSearchInputChange();
  }

  set value(brandCategoryId) {
    this._currentBrandCategoryId = brandCategoryId;
    const item = this.main.querySelector(`.brand_category_item[data-id="${brandCategoryId}"]`);

    if (item) {
      this._currentBrandCategoryName = item.getAttribute('data-name');
      this._valueLabel.textContent = this._currentBrandCategoryName;
      this.main.classList.add('brand-selector--filled');
    } else {
      this._currentBrandCategoryId = null;
      this._currentBrandCategoryName = null;
      this._valueLabel.textContent = 'Brand Category';
      this.main.classList.remove('brand-selector--filled');
    }
  }

  get value() {
    return this._currentBrandCategoryId;
  }

  get name() {
    return this._currentBrandCategoryName;
  }

  set actionButtonSize(size = 'big') {
    this._actionBtn.classList.remove(
      'form-input-box-actionable--size-2',
      'form-input-box-actionable--size-3'
    );
    if (size === 'small') {
      this._actionBtn.classList.add('form-input-box-actionable--size-3');
    } else if (size === 'medium') {
      this._actionBtn.classList.add('form-input-box-actionable--size-2');
    }
  }

  set background(bg = 'white') {
    this._actionBtn.classList.remove(
      'form-input-box-actionable--background-light-blue',
      'form-input-box-actionable--background-primary'
    );
    if (bg === 'light-blue') {
      this._actionBtn.classList.add('form-input-box-actionable--background-light-blue');
    } else if (bg === 'primary') {
      this._actionBtn.classList.add('form-input-box-actionable--background-primary');
    }
  }

  set showIcon(visible) {
    const icon = this.main.querySelector('.form-input-box-actionable__icon');
    if (icon) {
      icon.classList.toggle('d-none', !visible);
    }
  }

  set readOnly(flag) {
    this._readOnly = flag;
    this.main.classList.toggle('brand-selector--disabled', flag);
  }

  setValueDispatchingEvent(brandCategoryId) {
    this.value = brandCategoryId;
    this.main.dispatchEvent(new CustomEvent('brandCategoryChange'));
  }

  showTooltip() {
    this.main.classList.add('brand-selector--show-tooltip');
  }

  hideTooltip() {
    this.main.classList.remove('brand-selector--show-tooltip');
  }

  addEventListener(event, callback) {
    this.main.addEventListener(event, callback);
  }

  _onClickActionBtn() {
    if (this._readOnly) return;
    this._isOpen ? this.hide() : this.show();
  }

  _onSearchInputChange() {
    const search = this._searchInput.value.trim().toUpperCase();
    let hasResult = false;

    Array.from(this.main.querySelectorAll('.industry_item')).forEach(industry => {
      let industryVisible = false;

      Array.from(industry.querySelectorAll('.brand_category_item')).forEach(item => {
        const matches = !search || item.textContent.toUpperCase().includes(search);
        item.style.display = matches ? '' : 'none';
        industryVisible = industryVisible || matches;
        hasResult = hasResult || matches;
      });

      industry.style.display = industryVisible ? '' : 'none';
    });

    this._noResults.classList.toggle('d-none', hasResult);
  }

  _onClickBrandCategoryItem(e) {
    this.value = parseInt(e.currentTarget.getAttribute('data-id'), 10);
    this.hide();
    this.main.dispatchEvent(new CustomEvent('brandCategoryChange'));
  }

  _onClickDocument(e) {
    if (!this.main.contains(e.target) && this._isOpen) {
      this.hide();
    }
  }
}

export default BrandCategorySelector;
